import { Component, HostListener, Input } from '@angular/core';

import { Message } from '../../../models';
import { LinkConfirmationService } from '../../../services/link-confirmation.service';

@Component({
  selector: 'message-bot',
  templateUrl: './bot.component.html',
  styleUrls: ['./bot.component.scss'],
  standalone: false,
})
export class BotComponent {
  @Input('message') message!: Message;
  @Input() conversationId: string | null = null;

  constructor(private linkConfirmationService: LinkConfirmationService) {}

  @HostListener('click', ['$event'])
  @HostListener('auxclick', ['$event'])
  onLinkClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const anchor = target.closest('a');

    if (anchor && anchor.href && this.conversationId) {
      event.preventDefault();
      this.linkConfirmationService.openLink(anchor.href, this.conversationId);
    }
  }
}
